import { render, staticRenderFns } from "./OwnersMaintenanceRequests.vue?vue&type=template&id=63422930&scoped=true&"
import script from "./OwnersMaintenanceRequests.vue?vue&type=script&lang=js&"
export * from "./OwnersMaintenanceRequests.vue?vue&type=script&lang=js&"
import style0 from "./OwnersMaintenanceRequests.vue?vue&type=style&index=0&id=63422930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63422930",
  null
  
)

export default component.exports